const actions = {
  VENDOR_LIST_DATA_BEGIN: "VENDOR_LIST_DATA_BEGIN",
  VENDOR_LIST_DATA_SUCCESS: "VENDOR_LIST_DATA_SUCCESS",
  VENDOR_LIST_DATA_ERR: "VENDOR_LIST_DATA_ERR",
  VENDOR_LIST_DATA_RESET: "VENDOR_LIST_DATA_RESET",

  EXCHANGE_PROCESSING_DATA_BEGIN: "EXCHANGE_PROCESSING_DATA_BEGIN",
  EXCHANGE_PROCESSING_DATA_SUCCESS: "EXCHANGE_PROCESSING_DATA_SUCCESS",
  EXCHANGE_PROCESSING_DATA_ERR: "EXCHANGE_PROCESSING_DATA_ERR",
  EXCHANGE_PROCESSING_DATA_RESET: "EXCHANGE_PROCESSING_DATA_RESET",

  CHECK_AFFORDABILITY_BEGIN: "CHECK_AFFORDABILITY_BEGIN",
  CHECK_AFFORDABILITY_SUCCESS: "CHECK_AFFORDABILITY_SUCCESS",
  CHECK_AFFORDABILITY_ERR: "CHECK_AFFORDABILITY_ERR",
  CHECK_AFFORDABILITY_RESET: "CHECK_AFFORDABILITY_RESET",

  EXCHANGE_PROCESSING_SUBMIT_BEGIN: "EXCHANGE_PROCESSING_SUBMIT_BEGIN",
  EXCHANGE_PROCESSING_SUBMIT_SUCCESS: "EXCHANGE_PROCESSING_SUBMIT_SUCCESS",
  EXCHANGE_PROCESSING_SUBMIT_ERR: "EXCHANGE_PROCESSING_SUBMIT_ERR",
  EXCHANGE_PROCESSING_SUBMIT_RESET: "EXCHANGE_PROCESSING_SUBMIT_RESET",

  EXCHANGE_DASHBOARD_DATA_BEGIN: "EXCHANGE_DASHBOARD_DATA_BEGIN",
  EXCHANGE_DASHBOARD_DATA_SUCCESS: "EXCHANGE_DASHBOARD_DATA_SUCCESS",
  EXCHANGE_DASHBOARD_DATA_ERR: "EXCHANGE_DASHBOARD_DATA_ERR",

  EXCHANGE_HISTORY_DATA_BEGIN: "EXCHANGE_HISTORY_DATA_BEGIN",
  EXCHANGE_HISTORY_DATA_SUCCESS: "EXCHANGE_HISTORY_DATA_SUCCESS",
  EXCHANGE_HISTORY_DATA_ERR: "EXCHANGE_HISTORY_DATA_ERR",

  INHOUSE_REFERENCE_HISTORY_DATA_BEGIN: "INHOUSE_REFERENCE_HISTORY_DATA_BEGIN",
  INHOUSE_REFERENCE_HISTORY_DATA_SUCCESS: "INHOUSE_REFERENCE_HISTORY_DATA_SUCCESS",
  INHOUSE_REFERENCE_HISTORY_DATA_ERR: "INHOUSE_REFERENCE_HISTORY_DATA_ERR",

  EXCHANGE_VIEW_DATA_BEGIN: "EXCHANGE_VIEW_DATA_BEGIN",
  EXCHANGE_VIEW_DATA_SUCCESS: "EXCHANGE_VIEW_DATA_SUCCESS",
  EXCHANGE_VIEW_DATA_ERR: "EXCHANGE_VIEW_DATA_ERR",

  EXCHANGE_NEW_IMEI_LIST_BEGIN: "EXCHANGE_NEW_IMEI_LIST_BEGIN",
  EXCHANGE_NEW_IMEI_LIST_SUCCESS: "EXCHANGE_NEW_IMEI_LIST_SUCCESS",
  EXCHANGE_NEW_IMEI_LIST_ERR: "EXCHANGE_NEW_IMEI_LIST_ERR",
  EXCHANGE_NEW_IMEI_LIST_RESET: "EXCHANGE_NEW_IMEI_LIST_RESET",

  ECHANGE_SCHEME_LIST_BEGIN: "ECHANGE_SCHEME_LIST_BEGIN",
  ECHANGE_SCHEME_LIST_SUCCESS: "ECHANGE_SCHEME_LIST_SUCCESS",
  ECHANGE_SCHEME_LIST_ERR: "ECHANGE_SCHEME_LIST_ERR",
  ECHANGE_SCHEME_LIST_RESET: "ECHANGE_SCHEME_LIST_RESET",

  PAYMENT_METHOD_BEGIN: "PAYMENT_METHOD_BEGIN",
  PAYMENT_METHOD_SUCCESS: "PAYMENT_METHOD_SUCCESS",
  PAYMENT_METHOD_ERR: "PAYMENT_METHOD_ERR",
  PAYMENT_METHOD_RESET: "PAYMENT_METHOD_RESET",

  FILE_UPLOAD_BEGIN: "FILE_UPLOAD_BEGIN",
  FILE_UPLOAD_SUCCESS: "FILE_UPLOAD_SUCCESS",
  FILE_UPLOAD_ERR: "FILE_UPLOAD_ERR",
  FILE_UPLOAD_RESET: "FILE_UPLOAD_RESET",

  EXCHANGE_PICKUP_DATA_SUBMIT_BEGIN: "EXCHANGE_PICKUP_DATA_SUBMIT_BEGIN",
  EXCHANGE_PICKUP_DATA_SUBMIT_SUCCESS: "EXCHANGE_PICKUP_DATA_SUBMIT_SUCCESS",
  EXCHANGE_PICKUP_DATA_SUBMIT_ERR: "EXCHANGE_PICKUP_DATA_SUBMIT_ERR",
  EXCHANGE_PICKUP_DATA_RESET: "EXCHANGE_PICKUP_DATA_RESET",

  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_BEGIN: "INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_BEGIN",
  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_SUCCESS: "INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_SUCCESS",
  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_ERR: "INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_ERR",
  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_RESET: "INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_RESET",

  SUBMIT_EXCHANGE_DATA_BEGIN: "SUBMIT_EXCHANGE_DATA_BEGIN",
  SUBMIT_EXCHANGE_DATA_SUCCESS: "SUBMIT_EXCHANGE_DATA_SUCCESS",
  SUBMIT_EXCHANGE_DATA_ERR: "SUBMIT_EXCHANGE_DATA_ERR",
  SUBMIT_EXCHANGE_DATA_RESET: "SUBMIT_EXCHANGE_DATA_RESET",

  EXCHNAGE_INHOUSE_BEGIN: 'EXCHNAGE_INHOUSE_BEGIN',
  EXCHNAGE_INHOUSE_SUCCESS: 'EXCHNAGE_INHOUSE_SUCCESS',
  EXCHNAGE_INHOUSE_ERR: 'EXCHNAGE_INHOUSE_ERR',
  EXCHNAGE_INHOUSE_RESET: 'EXCHNAGE_INHOUSE_RESET',

  getVendorListDataBegin: () => {
    return {
      type: actions.VENDOR_LIST_DATA_BEGIN,
    };
  },
  getVendorListDataSuccess: (data) => {
    return {
      type: actions.VENDOR_LIST_DATA_SUCCESS,
      data,
    };
  },
  getVendorListDataErr: (err) => {
    return {
      type: actions.VENDOR_LIST_DATA_ERR,
      err,
    };
  },
  getVendorListDataReset: () => {
    return {
      type: actions.VENDOR_LIST_DATA_RESET,
    };
  },

  getExchangeProcessingDataBegin: () => {
    return {
      type: actions.EXCHANGE_PROCESSING_DATA_BEGIN,
    };
  },
  getExchangeProcessingDataSuccess: (data) => {
    return {
      type: actions.EXCHANGE_PROCESSING_DATA_SUCCESS,
      data,
    };
  },
  getExchangeProcessingDataErr: (err) => {
    return {
      type: actions.EXCHANGE_PROCESSING_DATA_ERR,
      err,
    };
  },
  getExchangeProcessingDataReset: () => {
    return {
      type: actions.EXCHANGE_PROCESSING_DATA_RESET,
    };
  },

  checkAffordabilityBegin: () => {
    return {
      type: actions.CHECK_AFFORDABILITY_BEGIN,
    };
  },

  checkAffordabilitySuccess: (data) => {
    return {
      type: actions.CHECK_AFFORDABILITY_SUCCESS,
      data,
    };
  },

  checkAffordabilityErr: (err) => {
    return {
      type: actions.CHECK_AFFORDABILITY_ERR,
      err,
    };
  },
  checkAffordabilityReset: () => {
    return {
      type: actions.CHECK_AFFORDABILITY_RESET,
    };
  },

  submitExchangeProcessingDataBegin: () => {
    return {
      type: actions.EXCHANGE_PROCESSING_SUBMIT_BEGIN,
    };
  },

  submitExchangeProcessingDataSuccess: (data) => {
    return {
      type: actions.EXCHANGE_PROCESSING_SUBMIT_SUCCESS,
      data,
    };
  },

  submitExchangeProcessingDataErr: (err) => {
    return {
      type: actions.EXCHANGE_PROCESSING_SUBMIT_ERR,
      err,
    };
  },

  getSubmitExchangeReset: () => {
    return {
      type: actions.SUBMIT_EXCHANGE_DATA_RESET,
    };
  },

  fileUploadBegin: (fileType) => ({
    type: actions.FILE_UPLOAD_BEGIN,
    payload: { fileType },
  }),

  fileUploadSuccess: (data, fileType) => ({
    type: actions.FILE_UPLOAD_SUCCESS,
    payload: { data, fileType },
  }),

  fileUploadErr: (err, fileType) => ({
    type: actions.FILE_UPLOAD_ERR,
    payload: { err, fileType },
  }),

  resetFileUpload: () => ({
    type: actions.FILE_UPLOAD_RESET,
  }),

  submitExchangeProcessingDataReset: () => {
    return {
      type: actions.EXCHANGE_PROCESSING_SUBMIT_RESET,
    };
  },

  getExchangeDashboardDataBegin: () => {
    return {
      type: actions.EXCHANGE_DASHBOARD_DATA_BEGIN,
    };
  },

  getExchangeDashboardDataSuccess: (data) => {
    return {
      type: actions.EXCHANGE_DASHBOARD_DATA_SUCCESS,
      data,
    };
  },

  getExchangeDashboardDataErr: (err) => {
    return {
      type: actions.EXCHANGE_DASHBOARD_DATA_ERR,
      err,
    };
  },

  getExchangeHistoryDataBegin: () => {
    return {
      type: actions.EXCHANGE_HISTORY_DATA_BEGIN,
    };
  },

  getExchangeHistoryDataSuccess: (data) => {
    return {
      type: actions.EXCHANGE_HISTORY_DATA_SUCCESS,
      data,
    };
  },

  getExchangeHistoryDataErr: (err) => {
    return {
      type: actions.EXCHANGE_HISTORY_DATA_ERR,
      err,
    };
  },

  getInhouseReferenceHistoryDataBegin: () => {
    return {
      type: actions.INHOUSE_REFERENCE_HISTORY_DATA_BEGIN,
    };
  },

  getInhouseReferenceHistoryDataSuccess: (data) => {
    return {
      type: actions.INHOUSE_REFERENCE_HISTORY_DATA_SUCCESS,
      data,
    };
  },

  getInhouseReferenceHistoryDataErr: (err) => {
    return {
      type: actions.INHOUSE_REFERENCE_HISTORY_DATA_ERR,
      err,
    };
  },

  getExchangeViewDataBegin: () => {
    return {
      type: actions.EXCHANGE_VIEW_DATA_BEGIN,
    };
  },

  getExchangeViewDataSuccess: (data) => {
    return {
      type: actions.EXCHANGE_VIEW_DATA_SUCCESS,
      data,
    };
  },

  getExchangeViewDataErr: (err) => {
    return {
      type: actions.EXCHANGE_VIEW_DATA_ERR,
      err,
    };
  },

  getExchangeNewIMEIListBegin: () => {
    return {
      type: actions.EXCHANGE_NEW_IMEI_LIST_BEGIN,
    };
  },

  getExchangeNewIMEIListSuccess: (data) => {
    return {
      type: actions.EXCHANGE_NEW_IMEI_LIST_SUCCESS,
      data,
    };
  },

  getExchangeNewIMEIListErr: (err) => {
    return {
      type: actions.EXCHANGE_NEW_IMEI_LIST_ERR,
      err,
    };
  },

  getExchangeNewIMEIListReset: () => {
    return {
      type: actions.EXCHANGE_NEW_IMEI_LIST_RESET,
    };
  },

  submitExchangePickupDataBegin: () => {
    return {
      type: actions.EXCHANGE_PICKUP_DATA_SUBMIT_BEGIN,
    };
  },

  submitExchangePickupDataSuccess: (data) => {
    return {
      type: actions.EXCHANGE_PICKUP_DATA_SUBMIT_SUCCESS,
      data,
    };
  },

  getExchangePickupDataReset: () => {
    return {
      type: actions.EXCHANGE_PICKUP_DATA_RESET,
    };
  },

  submitExchangePickupDataErr: (err) => {
    return {
      type: actions.EXCHANGE_PICKUP_DATA_SUBMIT_ERR,
      err,
    };
  },

  inhouseSubmitExchangePickupDataBegin: () => {
    return {
      type: actions.INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_BEGIN,
    };
  },

  inhouseSubmitExchangePickupDataSuccess: (data) => {
    return {
      type: actions.INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_SUCCESS,
      data,
    };
  },

  inhouseSubmitExchangePickupDataErr: (err) => {
    return {
      type: actions.INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_ERR,
      err,
    };
  },

  inhouseSubmitExchangePickupDataReset: () => {
    return {
      type: actions.INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_RESET,
    };
  },

  submitExchangeDataBegin: () => {
    return {
      type: actions.SUBMIT_EXCHANGE_DATA_BEGIN,
    };
  },

  submitExchangeDataSuccess: (data) => {
    return {
      type: actions.SUBMIT_EXCHANGE_DATA_SUCCESS,
      data,
    };
  },

  submitExchangeDataErr: (err) => {
    return {
      type: actions.SUBMIT_EXCHANGE_DATA_ERR,
      err,
    };
  },

  getSchemeListBegin: () => {
    return {
      type: actions.ECHANGE_SCHEME_LIST_BEGIN,
    };
  },

  getSchemeListSuccess: (data) => {
    return {
      type: actions.ECHANGE_SCHEME_LIST_SUCCESS,
      data,
    };
  },

  getSchemeListErr: (err) => {
    return {
      type: actions.ECHANGE_SCHEME_LIST_ERR,
      err,
    };
  },

  getSchemeListReset: () => {
    return {
      type: actions.ECHANGE_SCHEME_LIST_RESET,
    };
  },

  getPaymentMethodBegin: () => ({
    type: actions.PAYMENT_METHOD_BEGIN,
  }),

  getPaymentMethodSuccess: (data) => ({
    type: actions.PAYMENT_METHOD_SUCCESS,
    data,
  }),

  getPaymentMethodErr: (err) => ({
    type: actions.PAYMENT_METHOD_ERR,
    err,
  }),

  getPaymentMethodReset: () => {
    return {
      type: actions.PAYMENT_METHOD_RESET,
    };
  },

  postExchnageInhouseBegin : () => {
      return{
          type: actions.EXCHNAGE_INHOUSE_BEGIN,
      }
  },

  postExchnageInhouseSuccess : (data) => {
      return {
          type: actions.EXCHNAGE_INHOUSE_SUCCESS,
          data,
      };
  },  

  postExchnageInhouseErr : (err) => {
      return {
          type: actions.EXCHNAGE_INHOUSE_ERR,
          err,
      };
  },
  postExchnageInhouseReset : () => {
      return {
          type: actions.EXCHNAGE_INHOUSE_RESET,
      };
  },
};

export default actions;
